"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var fb_svg_1 = __importDefault(require("../../../../images/social-media/fb.svg"));
var messenger_svg_1 = __importDefault(require("../../../../images/social-media/messenger.svg"));
var telegram_svg_1 = __importDefault(require("../../../../images/social-media/telegram.svg"));
var whatsapp_svg_1 = __importDefault(require("../../../../images/social-media/whatsapp.svg"));
var viber_svg_1 = __importDefault(require("../../../../images/social-media/viber.svg"));
var vk_svg_1 = __importDefault(require("../../../../images/social-media/vk.svg"));
var odno_svg_1 = __importDefault(require("../../../../images/social-media/odno.svg"));
var linkedin_svg_1 = __importDefault(require("../../../../images/social-media/linkedin.svg"));
var twitter_svg_1 = __importDefault(require("../../../../images/social-media/twitter.svg"));
var copy_link_svg_1 = __importDefault(require("../../../../images/social-media/copy_link.svg"));
var copied_svg_1 = __importDefault(require("../../../../images/social-media/copied.svg"));
var useInterval_1 = __importDefault(require("../../../hooks/useInterval"));
var react_i18next_1 = require("react-i18next");
var react_share_1 = require("react-share");
var classnames_1 = __importDefault(require("classnames"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var ShareMedia = function () {
    var t = react_i18next_1.useTranslation('common').t;
    var url = window.location.href;
    var _a = react_1.useState(false), isCopied = _a[0], setIsCopied = _a[1];
    var copyImg = isCopied ? copied_svg_1.default : copy_link_svg_1.default;
    function copyToClipboard(text) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!('clipboard' in navigator)) return [3 /*break*/, 2];
                        return [4 /*yield*/, navigator.clipboard.writeText(text)];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2: return [2 /*return*/, document.execCommand('copy', true, text)];
                }
            });
        });
    }
    var onCopy = function () {
        copyToClipboard(url).then(function () {
            setIsCopied(true);
        });
    };
    useInterval_1.default(function () {
        setIsCopied(false);
    }, 4000);
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.mediaItems },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.item },
            react_1.default.createElement(react_share_1.FacebookShareButton, { url: url },
                react_1.default.createElement("img", { className: styles_module_scss_1.default.img, src: fb_svg_1.default })),
            react_1.default.createElement("span", { className: styles_module_scss_1.default.itemName }, 'Facebook')),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.item },
            react_1.default.createElement(react_share_1.FacebookMessengerShareButton, { url: url, appId: "process.env.MIX_MESSENGER_APP_ID" },
                react_1.default.createElement("img", { className: styles_module_scss_1.default.img, src: messenger_svg_1.default })),
            react_1.default.createElement("span", { className: styles_module_scss_1.default.itemName }, 'Messanger')),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.item },
            react_1.default.createElement(react_share_1.TelegramShareButton, { url: url },
                react_1.default.createElement("img", { className: styles_module_scss_1.default.img, src: telegram_svg_1.default })),
            react_1.default.createElement("span", { className: styles_module_scss_1.default.itemName }, 'Telegram')),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.item },
            react_1.default.createElement(react_share_1.WhatsappShareButton, { url: url },
                react_1.default.createElement("img", { className: styles_module_scss_1.default.img, src: whatsapp_svg_1.default })),
            react_1.default.createElement("span", { className: styles_module_scss_1.default.itemName }, 'WhatsApp')),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.item },
            react_1.default.createElement(react_share_1.ViberShareButton, { url: url },
                react_1.default.createElement("img", { className: styles_module_scss_1.default.img, src: viber_svg_1.default })),
            react_1.default.createElement("span", { className: styles_module_scss_1.default.itemName }, 'Viber')),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.item },
            react_1.default.createElement(react_share_1.VKShareButton, { url: url },
                react_1.default.createElement("img", { className: styles_module_scss_1.default.img, src: vk_svg_1.default })),
            react_1.default.createElement("span", { className: styles_module_scss_1.default.itemName }, 'VKontakte')),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.item },
            react_1.default.createElement(react_share_1.OKShareButton, { url: url },
                react_1.default.createElement("img", { className: styles_module_scss_1.default.img, src: odno_svg_1.default })),
            react_1.default.createElement("span", { className: styles_module_scss_1.default.itemName }, 'Odnoklassniki')),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.item },
            react_1.default.createElement(react_share_1.LinkedinShareButton, { url: url },
                react_1.default.createElement("img", { className: styles_module_scss_1.default.img, src: linkedin_svg_1.default })),
            react_1.default.createElement("span", { className: styles_module_scss_1.default.itemName }, 'LinkedIn')),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.item },
            react_1.default.createElement(react_share_1.TwitterShareButton, { url: url },
                react_1.default.createElement("img", { className: styles_module_scss_1.default.img, src: twitter_svg_1.default })),
            react_1.default.createElement("span", { className: styles_module_scss_1.default.itemName }, 'Twitter')),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.item },
            react_1.default.createElement("button", { className: styles_module_scss_1.default.copyLink, onClick: !isCopied ? onCopy : undefined },
                react_1.default.createElement("img", { className: styles_module_scss_1.default.img, src: copyImg })),
            react_1.default.createElement("span", { className: classnames_1.default(styles_module_scss_1.default.itemName, styles_module_scss_1.default.copyLinkText) }, isCopied
                ? t('POST_PREVIEW.LINK_COPIED')
                : t('POST_PREVIEW.COPY_LINK')))));
};
exports.default = react_1.memo(ShareMedia);
